<ng-container *transloco="let t; read: 'reports'">
<div class="p-5">
  <div>
    <drdp-title [title]="t('reportTracking.title')"></drdp-title>
  </div>
  <drdp-report-usage></drdp-report-usage>
  <drdp-agency-rating-views></drdp-agency-rating-views>
  <drdp-child-ratings></drdp-child-ratings>
</div>
</ng-container>
